import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { DATASET_KEY } from '@/utils/queryKeys';

import { Dataset } from '@/types/datasets.ts';

export function useDatasetsCacheDict(ids: string[]) {
  const results = useQueries({
    queries: ids.map((id) => ({ queryKey: DATASET_KEY(id), enabled: false })),
  });

  const data: Record<string, Dataset | undefined> = useMemo(
    () => Object.fromEntries(ids.map((id, i) => [id, results[i]?.data as Dataset | undefined])),
    [ids, results],
  );

  return data;
}
